import api from "./api";

export async function createShare() {
  const { data } = await api.post("/api/vault/share");
  return data; // { token, url, expires_at }
}

export async function getShare(token) {
  // Fetch via raw axios to avoid sending auth cookies from a public page (cookies will still be sent if same-origin; that's fine — backend ignores auth).
  const { data } = await api.get(`/api/vault/share/${token}`);
  return data; // { company, sections, docs, expires_at }
}

export async function downloadSharedDoc(token, docId) {
  const resp = await api.get(`/api/vault/share/${token}/docs/${docId}/download`, {
    responseType: "blob",
    timeout: 120000,
  });
  return resp;
}

export async function revokeShare(token) {
  const { data } = await api.post(`/api/vault/share/${token}/revoke`);
  return data;
}
